<div class="modal azure-wiki-navigator">
  <div class="modal-header">
    <h2 class="modal-header__title">{{ 'KNOWLEDGE_FEATURE.AZURE_WIKI.TITLE' | translate }}</h2>
    <button class="modal-header__close" (click)="cancel()">
      <ion-icon name="close"></ion-icon>
    </button>
  </div>

  <div class="modal-content">
    <div class="azure-wiki-navigator__loading" *ngIf="loading">
      <ion-spinner name="crescent"></ion-spinner>
    </div>

    <div class="azure-wiki-navigator__search" *ngIf="!loading">
      <input type="text"
             class="azure-wiki-navigator__search-input"
             [(ngModel)]="searchQuery"
             [placeholder]="'KNOWLEDGE_FEATURE.AZURE_WIKI.SEARCH_PLACEHOLDER' | translate" />
    </div>

    <!-- Proyectos ADO -->
    <ng-container *ngIf="!loading && viewStep === 'projects'">
      <div class="azure-wiki-navigator__empty" *ngIf="connectionMissing">
        {{ 'KNOWLEDGE_FEATURE.AZURE_WIKI.NO_CONNECTION' | translate }}
      </div>
      <div class="azure-wiki-navigator__empty" *ngIf="projects.length === 0 && !connectionMissing && !searchQuery">
        {{ 'KNOWLEDGE_FEATURE.AZURE_WIKI.NO_PROJECTS' | translate }}
      </div>
      <div class="azure-wiki-navigator__empty" *ngIf="filteredProjects.length === 0 && projects.length > 0 && searchQuery">
        {{ 'KNOWLEDGE_FEATURE.AZURE_WIKI.NO_SEARCH_RESULTS' | translate }}
      </div>
      <ul class="azure-wiki-navigator__list">
        <li class="azure-wiki-navigator__row azure-wiki-navigator__row--clickable"
            *ngFor="let adoProject of filteredProjects"
            (click)="selectProject(adoProject)">
          <ion-icon name="briefcase-outline"></ion-icon>
          <span class="azure-wiki-navigator__name">{{ adoProject.name }}</span>
        </li>
      </ul>
    </ng-container>

    <!-- Wikis del proyecto ADO -->
    <ng-container *ngIf="!loading && viewStep === 'wikis'">
      <div class="azure-wiki-navigator__breadcrumb">
        <button class="azure-wiki-navigator__link" (click)="loadProjects()">
          {{ 'KNOWLEDGE_FEATURE.AZURE_WIKI.PROJECTS' | translate }}
        </button>
        <span> / {{ selectedProject?.name }}</span>
      </div>
      <div class="azure-wiki-navigator__empty" *ngIf="stepLoadFailed">
        {{ 'KNOWLEDGE_FEATURE.AZURE_WIKI.LOAD_FAILED' | translate }}
      </div>
      <div class="azure-wiki-navigator__empty" *ngIf="wikis.length === 0 && !stepLoadFailed && !searchQuery">
        {{ 'KNOWLEDGE_FEATURE.AZURE_WIKI.NO_WIKIS' | translate }}
      </div>
      <div class="azure-wiki-navigator__empty" *ngIf="filteredWikis.length === 0 && wikis.length > 0 && searchQuery">
        {{ 'KNOWLEDGE_FEATURE.AZURE_WIKI.NO_SEARCH_RESULTS' | translate }}
      </div>
      <ul class="azure-wiki-navigator__list">
        <li class="azure-wiki-navigator__row azure-wiki-navigator__row--clickable"
            *ngFor="let wiki of filteredWikis"
            (click)="selectWiki(wiki)">
          <ion-icon name="book-outline"></ion-icon>
          <span class="azure-wiki-navigator__name">{{ wiki.name }}</span>
        </li>
      </ul>
    </ng-container>

    <!-- Árbol de páginas (completo en memoria, BR-33) -->
    <ng-container *ngIf="!loading && viewStep === 'pages'">
      <div class="azure-wiki-navigator__breadcrumb">
        <button class="azure-wiki-navigator__link" (click)="goBackToWikis()">
          {{ 'KNOWLEDGE_FEATURE.AZURE_WIKI.WIKIS' | translate }}
        </button>
        <span> / {{ selectedWiki?.name }}</span>
      </div>
      <div class="azure-wiki-navigator__empty" *ngIf="stepLoadFailed">
        {{ 'KNOWLEDGE_FEATURE.AZURE_WIKI.LOAD_FAILED' | translate }}
      </div>
      <div class="azure-wiki-navigator__empty" *ngIf="visibleRows.length === 0 && !stepLoadFailed && !searchQuery">
        {{ 'KNOWLEDGE_FEATURE.AZURE_WIKI.EMPTY_WIKI' | translate }}
      </div>
      <div class="azure-wiki-navigator__empty" *ngIf="filteredVisibleRows.length === 0 && visibleRows.length > 0 && searchQuery">
        {{ 'KNOWLEDGE_FEATURE.AZURE_WIKI.NO_SEARCH_RESULTS' | translate }}
      </div>
      <ul class="azure-wiki-navigator__list">
        <li class="azure-wiki-navigator__row"
            *ngFor="let row of filteredVisibleRows"
            [style.padding-left.px]="12 + row.depth * 20">
          <input type="checkbox"
                 [checked]="isSelected(row)"
                 (change)="toggleSelection(row)" />
          <button class="azure-wiki-navigator__expander"
                  *ngIf="row.hasChildren"
                  (click)="toggleExpand(row)">
            <ion-icon [name]="isExpanded(row) ? 'chevron-down-outline' : 'chevron-forward-outline'"></ion-icon>
          </button>
          <span class="azure-wiki-navigator__name">{{ row.page.pagePath }}</span>
          <span class="azure-wiki-navigator__date">{{ formatDate(row.page.lastModified) }}</span>
          <span class="azure-wiki-navigator__badge">
            {{ 'KNOWLEDGE_FEATURE.SOURCE_BADGE.AZURE_WIKI' | translate }}
          </span>
        </li>
      </ul>
    </ng-container>
  </div>

  <div class="modal-footer">
    <button class="btn-save"
            *ngIf="viewStep === 'pages' && isManagerOrAbove"
            [disabled]="selectedPagePaths.size === 0"
            (click)="confirmImport()">
      {{ 'KNOWLEDGE_FEATURE.AZURE_WIKI.IMPORT' | translate }}
    </button>
  </div>
</div>
